import React, { useState, useEffect, useRef } from "react";

import api from "../services/api";

//Momentjs
import moment from "moment";
import "moment/locale/pt-br";

//Feather
import {
  PhoneCall,
  MessageCircle,
  Filter
} from 'react-feather';

import {
  CBadge,
  CSpinner,
  CPagination,
  CPaginationItem,
  //Table
  CTable,
  CAvatar,
  CTableRow,
  CTableHead,
  CTableBody,
  CTableDataCell,
  CTableHeaderCell,
  CButton
} from "@coreui/react";

//Feather icons
import {
  X,
  Search
} from "react-feather";

//Components
import Box from "../components/Box";
import Popup from "../components/Popup";
import Button from "../components/Button";
import Reload from "../components/Reload";
import Textarea from "../components/Textarea";
import PopupTags from "../components/PopupTags";
import PhoneNumber from "../components/PhoneNumber";
import BoxCustomerMenu from "../components/BoxCustomerMenu";
import PopupSocialMedia from "../components/PopupSocialMedia";
import InputControlledMask from "../components/Forms/InputControlledMask";

//SVG"s
import Any from "../svgs/Any";
import openToast from "../utils/sweetAlert";

import { useForm } from "react-hook-form";
import { useAuth } from "../providers/auth";
import { useNavigate } from "react-router-dom";

import * as yup from "yup";

import { yupResolver } from "@hookform/resolvers/yup";
import useLocalStorage from "use-local-storage";
import LoadingCenter from "../components/LoadingCenter";
import PopupSocialMediaUserNew from "../components/PopupSocialMediaUserNew";
import TodoInput from "../components/TodoList/TodoInput";
import ChartHours from "../components/ChartHours";

const annotation = yup.object({
  annotation: yup.string(),
  call: yup.string().required("É necessário selecionar uma opção acima!").nullable()
}).required();

const advancedSearchSchema = yup.object({
  email: yup.string().email(),
  cpf: yup.string()
});

function NewCustomers() {
  const { register: registerAnnotation, handleSubmit: handleSubmitAnnotation, formState: { errors: errorsAnnotation } } = useForm({
    resolver: yupResolver(annotation)
  });

  const [feedbackButttonChat, setFeedbackButttonChat] = useState(false);
  //const [isOptionsOpen, setIsOptionsOpen] = useToggle();
  const inputFilesRef = useRef(null);
  const newCallId = useRef(null);

  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const [buttonPopupError, setButtonPopupError] = useState(false);
  const [buttonPopupSuccess, setButtonPopupSuccess] = useState(false);

  const [buttonPopupSuccessCall, setButtonPopupSuccessCall] = useState(false);
  const [feedbackButtton, setFeedbackButtton] = useState(false);

  const { user } = useAuth();

  let navigate = useNavigate();

  const [buttonPopupNewContact, setButtonPopupNewContact] = useState(false);

  const [buttonPopupSocialMediaFilter, setButtonPopupSocialMediaFilter] = useState(false);
  const [idCustomer, setIdCustomer] = useState("");
  const [infoLoadingCriarChat, setInfoLoadingCriarChat] = useState(false);
  const [socialMedias, setSocialMedias] = useState([]);

  const { register, handleSubmit, watch, formState: { errors } } = useForm();

  const [buttonPopup, setButtonPopup] = useState(false);
  const [buttonPopupSocial, setButtonPopupSocial] = useState(false);
  const [buttonPopupObs, setButtonPopupObs] = useState(false);
  const [search, setSearch] = useState("");

  const [info, setInfo] = useState();
  const [infoLoading, setInfoLoading] = useState(false);

  const [listPhones, setListPhones] = useState([]);
  const [positionList, setPositionList] = useState("");

  const g_graph2_enviado = useRef(null);

  const [callID, setCallID] = useState("");

  const [customers, setCustomers] = useState([]);
  const [qtdPag, setQtdPag] = useState("");

  const numberPage = useRef(1);

  const [totalCustomers, setTotalCustomers] = useState([]);
  const [customersLoading, setCustomersLoading] = useState(true);

  const [buttonPopupTags, setButtonPopupTags] = useState(false);
  const [buttonPopupSocialMedia, setButtonPopupSocialMedia] = useState(false);
  const [previous, setPrevious] = useState(true);
  const [next, setNext] = useState(false);

  const [infoLoadingLigar, setInfoLoadingLigar] = useState(false);

  async function pegaCliente(id, index) {
    // console.log(index);
    // setPositionList(index);
    const options = { headers: { "Authorization": "Bearer " + user.token } };
    try {
      setInfoLoadingLigar(true);
      const response = await api.get("/users/list/phone/" + id, options);
      setListPhones(response.data);

    } catch (error) {
      console.log(error);
    } finally {
      setInfoLoadingLigar(false);
    }
  }

  async function setNullBusy() {
    try {
      const response = await api.post("/users/update/busy/null/" + info.id, {}, { headers: { "Authorization": "Bearer " + user.token } });
    } catch (e) {
      console.log(e);
    }
  }

  async function setNumber(data) {
    setError("");

    try {
      const response = await api.post("/calls/ligarsl", { user_id: info.id, phone: data.number, set_busy: true }, { headers: { "Authorization": "Bearer " + user.token } });

      if (response.data.error == true) {
        setSuccess("");
        setError(response.data.message);
        setButtonPopupError(true);
      } else {
        setButtonPopupSuccessCall(true);
        setCallID(response.data.call_id);
        newCallId.current = response.data.call_id;

        setTimeout(() => {
          setFeedbackButtton(true);
        }, 10000);
      }
    } catch (e) {
      console.log(e);
    }
  }

  async function callFeedback(data) {
    try {

      if (data.call == 0) {
        setButtonPopupSuccessCall(false);
        setFeedbackButtton(false);
        newCallId.current = null;
        setCallID("");
        setFeedbackButttonChat(true);
      } else if (data.call == 1) {

        if (callID) {
          console.log("call feed IF ");
          const response = await api.post("/users/assumir/novo/ligacao/" + info.id, { call_id: callID, result_call: data.call, annotation: data.annotation }, { headers: { "Authorization": "Bearer " + user.token } });
        } else if (newCallId.current) {
          console.log("call feed ELSE IF ");
          const response = await api.post("/users/assumir/novo/ligacao/" + info.id, { call_id: newCallId.current, result_call: data.call, annotation: data.annotation }, { headers: { "Authorization": "Bearer " + user.token } });
        } else {
          console.log("call feed ELSE");
          const response = await api.post("/users/assumir/novo/ligacao/" + info.id, {}, { headers: { "Authorization": "Bearer " + user.token } });
        }
      }

    } catch (e) {
      console.log(e);
    }
    setButtonPopupNewContact(false);
    setButtonPopupSuccessCall(false);
    setCallID("");
    newCallId.current = null;
  }

  async function proxPage(page) {

    numberPage.current = page + 1;
    setPrevious(false);

    if (numberPage.current == qtdPag) {
      setNext(true);
    }

    const options = { headers: { "Authorization": "Bearer " + user.token } };
    setCustomersLoading(true);
    try {

      const response = await api.get("/users/new?page=" + numberPage.current, options);
      setCustomers(response.data.dados);

    } catch (error) {
      console.log(error);
    } finally {
      setCustomersLoading(false);
    }
  }

  async function previousPage(page) {

    numberPage.current = page - 1;
    if (numberPage.current == 1) {
      setPrevious(true);
    }

    const options = { headers: { "Authorization": "Bearer " + user.token } };
    setCustomersLoading(true);
    try {

      const response = await api.get("/users/new?page=" + numberPage.current, options);
      setCustomers(response.data.dados);

    } catch (error) {
      console.log(error);
    } finally {
      setCustomersLoading(false);
    }
  }

  async function fetchCustomers() {
    setError("");

    const options = { headers: { "Authorization": "Bearer " + user.token } };

    setCustomersLoading(true);

    try {
      const response = await api.get("/users/new?page=" + numberPage.current, options);

      setCustomers(response.data.dados);
      setQtdPag(response.data.qtd);

      if (response.data.error) {
        setError(response.data.message);
        openToast("info", "Atenção!", response.data.message);
      }

    } catch (error) {

      if (error.response) {
        openToast("info", "Atenção!", error.response.data.message);
      }

      console.log(error);
    } finally {
      setCustomersLoading(false);
    }
  }

  async function fetchCustomerById(id) {
    const options = { headers: { "Authorization": "Bearer " + user.token } };

    try {
      setInfoLoading(true);
      const response = await api.get("/users/" + id, options);
      setInfo(response.data);
    } catch (error) {
      console.log(error);
    } finally {
      setInfoLoading(false);
    }
  }

  useEffect(() => {
    fetchCustomers();
  }, []);

  //MEDIAS/TAGS
  const [media, setMedia] = useState("");
  const [access, setAccess] = useState("");
  const [tags, setTags] = useState([]);

  async function handleSearch(e) {
    if (e.key === "Enter") {
      setCustomersLoading(true);
      try {
        const response = await api.get(`/users/new/customers?social_media=${media}&search=${search}`, { headers: { "Authorization": "Bearer " + user.token } });

        setCustomers(response.data.dados);
      } catch (error) {
        console.log(error);
      } finally {
        setCustomersLoading(false);
      }
    }
  }

  const fetchCustomersWithFilter = async () => {
    setCustomersLoading(true);

    try {
      const response = await api.get(`/users/new/customers?social_media=${media}&search=${search}`, { headers: { "Authorization": "Bearer " + user.token } });

      setCustomers(response.data.dados);
      setButtonPopupTags(false);
      setButtonPopupSocialMedia(false);
    } catch (err) {
      console.log(err);
    } finally {
      setCustomersLoading(false);
    }
  }

  useEffect(() => {
    if (tags.length) fetchCustomersWithFilter();
  }, [tags]);

  useEffect(() => {
    if (media !== "") fetchCustomersWithFilter();
  }, [media]);

  useEffect(() => {
    if (access !== "") fetchCustomersWithFilter();
  }, [access]);

  async function pegaSocialMedia(id) {
    const options = { headers: { "Authorization": "Bearer " + user.token } };
    try {

      setInfoLoadingCriarChat(true);

      const response = await api.get("/users/socialmedia/" + id, options);
      setSocialMedias(response.data);
      setIdCustomer(id);

    } catch (error) {
      console.log(error);
    } finally {

      setInfoLoadingCriarChat(false);

    }
  }

  const [theme] = useLocalStorage("theme");

  const isDarkMode = theme === "dark";

  const paginationStyle = {
    "--cui-pagination-disabled-bg": isDarkMode ? "#2F3136" : "",
    "--cui-pagination-disabled-border-color": isDarkMode ? "#2F3136" : "",
    "--cui-pagination-bg": isDarkMode ? "#27282C" : ""
  };

  /**
   *
   *
   *
   */
  const { handleSubmit: handleSubmitAdvancedSearch, control: controlAdvancedSearch, reset: resetAdvancedSearch, formState: { errors: errorsAdvancedSearch } } = useForm({
    resolver: yupResolver(advancedSearchSchema)
  });

  const [advancedSearch, setAdvancedSearch] = useState(false);

  const handleAdvancedSearch = (data) => {
    console.log(data);
  }

  useEffect(() => {
    resetAdvancedSearch();
  }, [advancedSearch]);

  return (
    <div className="customer-grid">

      <Popup title="Pesquisa avançada" trigger={advancedSearch} setTrigger={setAdvancedSearch} width="420">
        <div className="x-p-20">
          <form onSubmit={handleSubmitAdvancedSearch(handleAdvancedSearch)}>
            <InputControlledMask label="E-mail" mask="" type="text" placeholder="E-mail" name="email" error={errorsAdvancedSearch.email} control={controlAdvancedSearch} />
            <InputControlledMask label="Cpf" mask="999.999.999-99" type="text" placeholder="Cpf" name="cpf" error={errorsAdvancedSearch.cpf} control={controlAdvancedSearch} />
            <div className="d-flex flex-row justify-content-between mt-20 mb-20">
              <div></div>
              <div>
                <CButton color="danger" variant="ghost" onClick={() => setAdvancedSearch(false)}>Cancelar</CButton>
                <CButton type="submit" color="primary" className="ml-10">Pesquisar</CButton>
              </div>
            </div>
          </form>
        </div>
      </Popup>

      <PopupSocialMediaUserNew setSelectedMedia={setMedia} socialMedias={socialMedias} trigger={buttonPopupSocialMediaFilter} setTrigger={setButtonPopupSocialMediaFilter} idCustomer={idCustomer} infoLoadingCriarChat={infoLoadingCriarChat} />

      <Popup title="Selecionar telefone" trigger={buttonPopupNewContact} setTrigger={setButtonPopupNewContact} >
        {infoLoadingLigar ?
          (
            <LoadingCenter />
          ) : (
            <form onSubmit={handleSubmit(setNumber)}>
              <div className="padding-inner" style={{ paddingTop: "0px" }}>

                {customersLoading ? (
                  <LoadingCenter />
                ) : (
                  <div className="sm-body">
                    <div className="row-grid">
                      {listPhones.map((phone, index) => {
                        return (
                          <PhoneNumber key={index} title={phone.name} name="number" value={phone.name} qtd={phone.qtd} lastOne={String(phone.lastOne)} register={register} />
                        )
                      })}
                    </div>
                  </div>
                )}

                {error ? (
                  <div className="mt-20 d-flex flex-row justify-content-center align-center" style={{ color: "red" }}>
                    {error}
                  </div>
                ) : (
                  ""
                )}

              </div>

              <div className="padding-lbr">
                <Button title="Ligar" type="submit" color="green" width="full" loading={false} />
              </div>
            </form>
          )}
      </Popup>

      <Popup title="Gerenciar tags" trigger={buttonPopup} setTrigger={setButtonPopup} >
        <div className="padding-inner">
          <span className="popup-label">Tags do seu cliente</span>

          <div className="inner-search ml-20" style={{ height: "45px" }}>
            <div className="search-icon">
              <Search size={24} />
            </div>
            <input className="search-input" onKeyPress={handleSearch} type="text" placeholder="Pressione enter p/ pesquisar" onChange={e => setSearch(e.target.value)} value={search} />
          </div>

          <div className="tag-delete">
            <div className="tag-delete-inner">
              <span>#colheitadeira</span>
              <button className="btn-tag-delete">
                <X size={18} />
              </button>
            </div>
          </div>
        </div>

        {/* <div className="padding-lbr">
          Lorem ipsum
        </div> */}

        <div className="padding-lbr">
          <Button title="Adicionar" type="submit" color="green" width="full" loading={false} onClick={() => { }} />
        </div>
      </Popup>

      {/* <Popup title="Resultado da ligação" trigger={buttonPopupSuccessCall}   >

        <div className="sm-body no-padd-top">
          <form onSubmit={handleSubmit(callFeedback)}>
            <span className="popup-label">Você conseguiu falar com o cliente?</span>
            <div className="popup-footer mt-10">
              {feedbackButtton ? (
                <>
                  <button className="btn btn-primary" type="submit" onClick={() => { setFeedbackButtton(false); }}>Sim</button>
                  <button className="btn btn-light mr-20" onClick={() => { setButtonPopupSuccessCall(false); setFeedbackButtton(false); setCallID(""); newCallId.current = null; setNullBusy(); }}>Não</button>
                </>
              ) : (
                <>
                  <button style={{ cursor: "not-allowed" }} className="btn btn-primary" onClick={(e) => e.preventDefault()}>Sim</button>
                  <button style={{ cursor: "not-allowed" }} className="btn btn-light mr-20" onClick={(e) => e.preventDefault()}>Não</button>
                </>
              )}
            </div>
          </form>
        </div>
      </Popup> */}

      <Popup title="Resultado da ligação" trigger={buttonPopupSuccessCall} setTrigger={setButtonPopupSuccessCall}>
        <div className="sm-body no-padd-top">
          {/* <form onSubmit={handleSubmitAnnotation(sendCallAnnotation)}> */}
          <form onSubmit={handleSubmitAnnotation(callFeedback)}>
            <span style={{ display: "block", fontWeight: 600, fontSize: "16px", color: "var(--secondary-color)" }} className="mt-20">
              Você conseguiu falar com o cliente?
            </span>

            <ul className="last-access-list mt-20">
              <li>
                <label className="label-last-accesses">
                  <input type="radio" name="call" value="1" {...registerAnnotation("call")} />
                  <span>Sim</span>
                </label>
              </li>
              <li>
                <label className="label-last-accesses">
                  <input type="radio" name="call" value="0" {...registerAnnotation("call")} />
                  <span>Não</span>
                </label>
              </li>
            </ul>

            {errorsAnnotation.call && <div className="text-error">{errorsAnnotation.call.message}</div>}

            <Textarea label="Anotação" name="annotation" type="text"
              placeholder="Insira uma anotação relacioanda a ligação (opcional)"
              error={errorsAnnotation.annotation} register={registerAnnotation} />

            <div className="popup-footer mt-10">
              {feedbackButtton ? (
                <button className="btn btn-light" type="submit">Enviar</button>
              ) :
                <button style={{ cursor: "not-allowed" }} className="btn btn-light" onClick={(e) => e.preventDefault()}>Enviar</button>
              }
            </div>
          </form>
        </div>
      </Popup>

      <PopupTags setSelectedTags={setTags} trigger={buttonPopupTags} setTrigger={setButtonPopupTags} />

      <PopupSocialMedia setSelectedMedia={setMedia} trigger={buttonPopupSocialMedia} setTrigger={setButtonPopupSocialMedia} />

      <div className="customer-container">

        <div className="header flex-separate border-bottom fix-top">
          <span>
            Clientes novos
          </span>

          <div className="navigation">
            <div className="inner-search ml-20" style={{ height: "45px" }}>
              <div className="search-icon">
                <Search size={24} />
              </div>
              <input className="search-input" onKeyPress={handleSearch} type="text" placeholder="Pressione enter p/ pesquisar" onChange={e => setSearch(e.target.value)} value={search} />
            </div>

            <button className="dropdown__btn rounded__btn ml-10" style={{ width: "44px", height: "44px" }}
              onClick={() => setAdvancedSearch(true)}>
              <Filter />
            </button>
          </div>
        </div>

        <div className="table-container">
          {customersLoading ? (
            <LoadingCenter />
          ) : (
            <>
              {error && <Reload title="Atenção" message={error} onClick={() => fetchCustomers()} />}
              {customers &&
                <>
                  <CTable hover color={theme}>
                    <CTableHead>
                      <CTableRow>
                        <CTableHeaderCell scope="col">
                          <span className="">Foto</span>
                        </CTableHeaderCell>
                        <CTableHeaderCell scope="col">
                          <span className="">Nome completo</span>
                        </CTableHeaderCell>
                        <CTableHeaderCell scope="col">
                          <span className="">Data Cadastro</span>
                        </CTableHeaderCell>
                        <CTableHeaderCell scope="col">
                          <span className="">Status</span>
                        </CTableHeaderCell>
                        <CTableHeaderCell scope="col">
                          <span className="">Aprovação</span>
                        </CTableHeaderCell>

                        <CTableHeaderCell scope="col"><div align="center" className=""><PhoneCall size={22} /></div></CTableHeaderCell>
                        <CTableHeaderCell scope="col"><div align="center" className=""><MessageCircle size={22} /></div></CTableHeaderCell>
                      </CTableRow>
                    </CTableHead>
                    <CTableBody>
                      {customers.map((customer, index) => {
                        return (
                          //<CTableRow key={index} onClick={() => fetchCustomerById(customer.id)} ref={g_graph2_enviado}>
                          <CTableRow key={index} onClick={() => fetchCustomerById(customer.id)} >
                            <CTableHeaderCell scope="row">
                              <CAvatar color="light" textColor="dark" style={{ backgroundImage: `url(${customer.profile_pic})`, backgroundPosition: "center", backgroundRepeat: "no-repeat", backgroundSize: "cover" }}></CAvatar>
                            </CTableHeaderCell>
                            <CTableDataCell>
                              <span className="">{customer.name}</span> {customer.link_usadao
                                ? <CBadge style={{ marginLeft: "15px" }} color="warning" href={customer.link_usadao}>#{customer.usadao_id}</CBadge>
                                : <CBadge style={{ marginLeft: "15px" }} color="dark">Sem cadastro</CBadge>}
                            </CTableDataCell>
                            <CTableDataCell>
                              <span className={`message-box-date `}>
                                {moment(customer.createdAt).format("LL")}
                              </span>
                            </CTableDataCell>
                            <CTableDataCell>{customer.status ? <CBadge color="success">Ativo</CBadge> : <CBadge color="danger">Inativo</CBadge>}</CTableDataCell>
                            <CTableDataCell>{customer.approved ? <CBadge color="success">Apovado</CBadge> : <CBadge color="danger">Desaprovado</CBadge>}</CTableDataCell>
                            <CTableDataCell>
                              <div align="center"><button className="btn btn-primary" onClick={() => { setButtonPopupNewContact(true); pegaCliente(customer.id, index) }}>Ligar</button></div>
                            </CTableDataCell>
                            <CTableDataCell>
                              <div align="center"><button className="btn btn-warning" type="submit" onClick={() => { setButtonPopupSocialMediaFilter(true); pegaSocialMedia(customer.id) }}>+Chat</button></div>
                            </CTableDataCell>
                          </CTableRow>
                        )
                      })}
                    </CTableBody>
                  </CTable>
                </>
              }
              <CPagination align="center" aria-label="Navegação da tabela de clientes" className="m-t-20" style={paginationStyle}>
                <CPaginationItem disabled={previous} onClick={() => previousPage(numberPage.current)}>
                  <span className="text-color">Anterior</span>
                </CPaginationItem>
                <CPaginationItem disabled={next} onClick={() => proxPage(numberPage.current)}>
                  <span className="text-color">Próximo</span>
                </CPaginationItem>
              </CPagination>
            </>
          )}
        </div>
      </div>

      <div className="customer">
        <div className="header border-left">
          <span>
            Informações
          </span>
          {info && info.usadao_id != '' &&
            <a href={`https://usadaomaquinas.com.br/Gerencial_web32yw/PG_Clientes/DashCliente.php?Codigo=` + info.usadao_id} target="_blank">
              <button className="action-btn">
                <img src={require("../imgs/icon-colored.png")} />
              </button>
            </a>
          }
        </div>

        {info ? (
          <div className="chat-user">
            <div className="box no-bg">
              <div className="box-avatar-wrapper">
                <div className="box-avatar" style={{ backgroundImage: `url(${info.profile_pic})` }}></div>
              </div>
              {info && info.usadao_id != '' && (
                <span className="chat-user-id">#{info.usadao_id}</span>
              )}
              <span className="chat-user-username">{info.nickname}</span>
              <span className="chat-user-name">{info.name && info.name}</span>
              {info.dataAniversario && (
                <span className="chat-user-username">Idade: {info.year} anos</span>)
              }

              {info.ultimaVizualizacao && (
                <span className="chat-user-username">Ultimo login no leilão:</span>)}
              {info.ultimaVizualizacao && (
                <span className="chat-user-id">{moment(info.ultimaVizualizacao).format('LLL')}</span>)}

              {info.city_name && info.state_name && (
                <span className="chat-user-username">{info.city_name} / {info.state_name}</span>)
              }
            </div>
            {info.usadao_id != '' &&
              <BoxCustomerMenu user={info} disabled={true} />
            }
            {/* <Box title="Documentos" defaultOpen={true}>
              <DocDropzone ref={inputFilesRef} user={info} disabled={true} />
            </Box> */}

            <Box title="Tags" defaultOpen={true}>
              {info.tags.map((tag, index) =>
                <div key={index} className="tag">
                  <span>#{tag.name}</span>
                </div>
              )}
            </Box>

            <Box title="Observações" defaultOpen={true}>
              {info?.observations.map((item, index) => {
                return (
                  <div className="observation-box text-color">
                    <div>
                      <span className="observation-box__author">{item.author}</span>
                    </div>
                    <p className="observation-box__body">
                      {item.body}
                    </p>
                  </div>
                );
              })}
            </Box>

            <Box title="Redes sociais" defaultOpen={false}>
              {info.socialMedias.map((media, index) => {
                return (
                  <img key={index} src={`${media.icon}`} style={{ marginRight: "10px", marginBottom: "15px" }} />
                )
              })}
            </Box>

            {info && <ChartHours user={info.id} />}

          </div>
        ) : (
          infoLoading ? (
            <LoadingCenter />
          ) : (
            <div className="div-center pt-20 pl-20 pr-20 text-center">
              <Any />
              <span className="chat-user-name">Nenhum cliente</span>
              <span className="chat-user-username">
                Você deve selecionar um cliente para visualizar as informações
              </span>
            </div>
          )
        )}

      </div>
    </div>
  );
}

export default NewCustomers;